import { CSSProperties } from 'styled-components';

export type GapProps = {
  gap?: CSSProperties['gap'];
  rowGap?: CSSProperties['rowGap'];
  columnGap?: CSSProperties['columnGap'];
};

export const gap = (props: GapProps) => ({
  gap: props.gap,
  rowGap: props.rowGap,
  columnGap: props.columnGap,
});
